<ng-container *ngTemplateOutlet="school_card"></ng-container>

<ng-template #school_card let-isModal="isModal">
  <article
    *ngIf="loaded"
    class="school-card {{ view }}"
    [class.modal]="isModal || modal"
    [class.mobile]="deviceService.isMobile()">
    <div class="cover-wrap">
      <on-ui-cover [cover]="coverImg"></on-ui-cover>
    </div>
    <div class="header">
      <div class="participants-block">
        <div
          *ngFor="let participant of filteredTeachers(participants); let i = index; trackBy: participantsTrackByFn"
          [style.transform]="'translateX(' + -8 * i + 'px)'"
          class="teacher">
          <on-ui-cover [cover]="avatarParticipant(school.owners ? participant : participant.account)"></on-ui-cover>
        </div>
      </div>
      <div class="tools-block">
        <div class="copy-informer" [class.active]="copied">
          <span>{{ 'invite-card.link-copied' | translate }}</span>
        </div>
        <app-bookmark [item]="school" type="school" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
        <on-ui-card-menu>
          <ng-template [ngIf]="meIsOwnerSchool" [ngIfElse]="all">
            <div
              class="menu-item"
              #shareLinkRef
              [ngxClipboard]
              [cbContent]="fullSchoolUrl"
              (cbOnSuccess)="onCopied($event)"
              [container]="shareLinkRef">
              {{ 'school-card.actions.share' | translate }}
            </div>
            <div class="menu-item" (click)="onEditSchool()">{{ 'school-card.actions.edit' | translate }}</div>
            <div class="menu-item" (click)="onToggleAlert()">{{ 'school-card.actions.delete' | translate }}</div>
          </ng-template>
          <ng-template #all>
            <div
              class="menu-item"
              #shareLinkRef
              [ngxClipboard]
              [cbContent]="fullSchoolUrl"
              (cbOnSuccess)="onCopied($event)"
              [container]="shareLinkRef">
              {{ 'school-card.actions.share' | translate }}
            </div>
            <div class="menu-item">{{ 'school-card.actions.complain' | translate }}</div>
          </ng-template>
        </on-ui-card-menu>
      </div>
    </div>
    <div class="meta">
      <a [routerLink]="schoolUrl" [title]="title" class="title-wrap">
        <h3 class="title">{{ title }}</h3>
      </a>
      <p class="description" [innerHTML]="description | striptags"></p>
      <app-rating [stats]="school" [label]="true"></app-rating>
      <div class="participants-count">
        {{ 'school-card.students' | translate }} {{ filteredStudents(participants).length || 0 }}
      </div>
    </div>
    <div class="footer">
      <div class="teaching-wrap" [class.mobile]="deviceService.isMobile()">
        <div
          *ngFor="
            let subject of isModal || modal
              ? subjects || []
              : deviceService.isMobile() || view === 'mini'
              ? (subjects || []).slice(0, 2)
              : (subjects || []).slice(0, 3);
            trackBy: subjectsTrackByFn
          "
          [class.active]="subject.id == subjectId"
          (click)="setSubject(subject.id)"
          class="teaching-subject-item">
          <span class="subject-title">{{ getSubjectTitle(subject) }}</span>
        </div>
        <ng-template
          [ngIf]="(deviceService.isMobile() ? (subjects || []).length > 2 : (subjects || []).length > 3) && !isModal">
          <span class="more-action"
            >+{{ deviceService.isMobile() ? (subjects || []).slice(2).length : (subjects || []).slice(3).length }}</span
          >
        </ng-template>
      </div>
      <div class="action-block">
        <div class="action">
          <ng-template [ngIf]="!isModal && !modal">
            <on-ui-button
              class="primary outline"
              iconPosition="after"
              label="school-card.actions.details"
              (onclick)="onOpenCardInModal()">
              <app-icon width="12" height="7" file="chevron" icon="down"></app-icon>
            </on-ui-button>
          </ng-template>
        </div>
        <ng-template [ngIf]="isParticipant" [ngIfElse]="join">
          <div class="action participant">
            <on-ui-button class="primary" label="school-card.actions.enter" (onclick)="navigateToPage()">
            </on-ui-button>
          </div>
        </ng-template>
        <ng-template #join>
          <div class="action">
            <on-ui-button
              class="primary"
              [state]="addParticipantActionState"
              label="school-card.actions.join"
              (onclick)="onAddParticipant()">
            </on-ui-button>
          </div>
        </ng-template>
      </div>
    </div>
  </article>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && schoolForm" (closed)="onToggleForm()">
  <app-modal-body>
    <app-school-form [modalDisplayMode]="true" [school]="school" (changed)="onToggleForm($event)"> </app-school-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && schoolForm" [titleVisible]="false" (closed)="onToggleForm()">
  <app-mobile-modal-body>
    <div class="modal-title-wrap">
      <span class="title bold">{{ 'school-form.header' | translate }}</span>
    </div>
    <div class="modal-title-gap"></div>
    <app-school-form [modalDisplayMode]="true" [school]="school" (changed)="onToggleForm($event)"> </app-school-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-alert *ngIf="alertOpened" type="error">
  <ng-container alert-title>{{ 'delete-school.header' | translate }}</ng-container>
  <ng-container alert-body>{{ 'delete-school.text' | translate }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline" label="delete-school.close" (onclick)="onToggleAlert()"> </on-ui-button>
    <on-ui-button class="danger" label="delete-school.delete" (onclick)="onRemoveSchool()"> </on-ui-button>
  </ng-container>
</app-alert>

<app-modal *ngIf="!deviceService.isMobile() && cardInModal" [canClose]="false" (closed)="onCloseCardInModal()">
  <app-modal-body>
    <app-school-page [isModal]="true" [slug]="school.slug" [subjectId]="subjectId"></app-school-page>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && cardInModal" (closed)="onCloseCardInModal()">
  <app-mobile-modal-body>
    <app-school-page [isModal]="true" [slug]="school.slug" [subjectId]="subjectId"></app-school-page>
  </app-mobile-modal-body>
</app-mobile-modal>
